import {
  Avatar,
  Box,
  Divider,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import HistoryIcon from "@mui/icons-material/History";
import StarIcon from "@mui/icons-material/Star";
import UpdateIcon from "@mui/icons-material/SystemUpdateAlt";
import LogoutIcon from "@mui/icons-material/Logout";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useState } from "react";

export default function UserMenu({
  userData,
  token,
  handleCopy,
  handleLogout,
  navigate,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <>
      <MoreVertIcon
        onClick={handleMenuOpen}
        style={{ cursor: "pointer", color: "white", fontSize: 25 }}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 220,
            p: 1,
            boxShadow: "0px 4px 16px rgba(0,0,0,0.15)",
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* Üst Bilgi */}
        <Box display="flex" alignItems="center" px={1.5} py={1}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              mr: 1,
              fontSize: "16px",
              fontWeight: 600,
              background: "linear-gradient(135deg, #CBD5E1 0%, #94A3B8 100%)",
              color: "#1C355E",
            }}
          >
            {/* {userData?.fullname?.split(' ').map(n => n[0]).join('').slice(0, 2) || "U"} */}
            {userData?.fullname?.split(" ")[0]?.[0] || "U"}
          </Avatar>

          <Box>
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {userData?.fullname || "Kullanıcı"}
            </Typography>
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              {userData?.company || "Simzset Yazılım"}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        {/* Menü Öğeleri */}
        <MenuItem onClick={() => navigate("/profil")} sx={{ fontSize: 13 }}>
          <ListItemIcon>
            <IntegrationInstructionsIcon fontSize="small" />
          </ListItemIcon>
          Profili Gör
        </MenuItem>

        <MenuItem onClick={handleCopy} sx={{ fontSize: 13 }}>
          <ListItemIcon>
            <ContentCopyIcon fontSize="small" />
          </ListItemIcon>
          Token Kopyala
        </MenuItem>

        {/* <MenuItem sx={{ fontSize: 13 }}>
          <ListItemIcon>
            <HistoryIcon fontSize="small" />
          </ListItemIcon>
          Geçmiş
        </MenuItem>

        <MenuItem sx={{ fontSize: 13 }}>
          <ListItemIcon>
            <StarIcon fontSize="small" sx={{ color: "#f5b300" }} />
          </ListItemIcon>
          Pro’ya Yükselt
        </MenuItem>

        <MenuItem sx={{ fontSize: 13, bgcolor: "rgba(0,200,0,0.05)" }}>
          <ListItemIcon>
            <UpdateIcon fontSize="small" color="success" />
          </ListItemIcon>
          Uygulamayı Güncelle
        </MenuItem> */}

        <Divider sx={{ my: 0.5 }} />

        <MenuItem onClick={handleLogout} sx={{ fontSize: 13 }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="error" />
          </ListItemIcon>
          Çıkış Yap
        </MenuItem>

        <Box textAlign="center" pt={0.5} pb={0.8}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
            v1.3.0 • <u>Simzet Yazılım</u>
          </Typography>
        </Box>
      </Menu>
    </>
  );
}
